// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__nZIzi","label":"styles_label__ca6VT","icon":"styles_icon__6a8Ic"};